import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, Container, Form, Offcanvas } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  apiDeleteProcess,
  apiGetProcess,
  apiGetProcesses,
  apiUpdateProcess,
} from "../../api/ApiProcess";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import { selectReduxInstance } from "../../redux/ReduxInstance";
import ReactFlow, {
  addEdge,
  applyEdgeChanges,
  applyNodeChanges,
  Background,
  Controls,
  MiniMap,
  ReactFlowProvider,
} from "react-flow-renderer";
import "react-flow-renderer/dist/theme-default.css";
import CustomNode from "../../components/admin/process/CustomNode";
import { Link, useNavigate, useParams } from "react-router-dom";
import ModalCreateUpdate from "../../components/admin/process/ModalCreateUpdate";
import { MdOutlineAdd } from "react-icons/md";
import ComponentBreadcrumb from "../../components/public/process/ComponentBreadcrumb";
import ModalChoixResponsables from "../../components/admin/process/ModalChoixResponsables";
import { MdArrowBack } from "react-icons/md";
import CustomEdge from "../../components/admin/process/ButtonEdges";
import { useTranslation } from "react-i18next";

const PageAdminEditView = () => {
  const { t } = useTranslation();
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const reactFlowWrapper = useRef(null);
  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);

  const ReduxInstance = useSelector(selectReduxInstance);
  let { id } = useParams();
  const navigate = useNavigate();

  const [processes, setProcesses] = useState([]);
  const [process, setProcess] = useState("");
  const [showCreateProcess, setShowCreateProcess] = useState(false);
  const [showChoixResponsables, setShowChoixResponsables] = useState(false);
  const [processLoaded, setProcessLoaded] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [lastSave, setLastSave] = useState("");

  const [query, setQuery] = useState("");
  const [selectedNode, setSelectedNode] = useState("");
  const [entryMode, setEntryMode] = useState(false);

  const [showNodeMenu, setShowNodeMenu] = useState(false);
  const handleCloseNodeMenu = () => {
    setSelectedNode("");
    setShowNodeMenu(false);
  };
  const handleShowNodeMenu = () => setShowNodeMenu(true);

  const getId = (procId) => {
    return `dndnode_${procId}_${new Date().getTime()}`;
  };

  useEffect(() => {
    if (id) {
      recupProcess();
      recupProcesses();
    }
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  /**
   * À chaque modifications du schèma on va enregistrer les modifications.
   * processLoaded : Permet de ne pas enregistrer le schèma au démarrage de la page, on attend que les élements soit chargé pour écouter
   * les modifications
   */
  useEffect(() => {
    if (processLoaded) {
      onSubmit();
    }
  }, [nodes, edges]); // eslint-disable-line react-hooks/exhaustive-deps

  // Lorsqu'on connecte un node à un autre node.
  const onConnect = (params) => {
    params.type = "buttonedge";
    params.arrowHeadType = "arrowclosed";
    params.style = { strokeWidth: 2 };
    setEdges((els) => addEdge(params, els));
  };

  const onNodesChange = (changes) => {
    changes.forEach((change) => {
      if (change.type === "remove") {
        let myNode = reactFlowInstance.getNode(change.id);
        if (myNode.data.template === 0) {
          apiDeleteProcess(myNode.data.process._id);
          recupProcesses();
        }
      }
    });
    if (changes[0].type === "remove") {
      setSelectedNode("");
    }
    setNodes((ns) => applyNodeChanges(changes, ns));
  };

  const onEdgesChange = useCallback(
    (changes) => setEdges((es) => applyEdgeChanges(changes, es)),
    []
  );
  const onDragStart = (event, nodeType, process) => {
    event.dataTransfer.setData("application/reactflow", nodeType);
    event.dataTransfer.setData("process", JSON.stringify(process));
    event.dataTransfer.effectAllowed = "move";
  };

  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }, []);

  // Lorsqu'on dépose un process dans le tableau
  const onDrop = useCallback(
    (event) => {
      event.preventDefault();

      const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
      const type = event.dataTransfer.getData("application/reactflow");
      const process = event.dataTransfer.getData("process");

      // check if the dropped element is valid
      if (typeof type === "undefined" || !type) {
        return;
      }

      const position = reactFlowInstance.project({
        x: event.clientX - reactFlowBounds.left,
        y: event.clientY - reactFlowBounds.top,
      });

      const newNode = {
        id: getId(JSON.parse(process)._id),
        type,
        position,
        data: { process: JSON.parse(process), template: entryMode ? 2 : 1 },
      };

      setNodes((nds) => nds.concat(newNode));
    },
    [reactFlowInstance]
  );

  const addProcessToBoard = (processus) => {
    const id = getId(processus._id);
    const type = "special";

    const newNode = {
      id,
      type,
      position: {
        x: Math.floor(Math.random() * 5) * 100,
        y: Math.floor(Math.random() * 5) * 100,
      },
      data: { process: processus, template: 0 },
    };
    reactFlowInstance.addNodes(newNode);
  };

  // Initialisation du Node Custom
  const nodeTypes = useMemo(() => ({ special: CustomNode }), []);
  const edgeTypes = useMemo(() => ({ buttonedge: CustomEdge }), []);

  const recupProcesses = async () => {
    const res = await apiGetProcesses(ReduxInstance._id, "filter[_id][$ne]=" + id);
    if (res) {
      setProcesses(res.data);
    } else {
      console.log("error");
    }
  };

  const recupProcess = async () => {
    const res = await apiGetProcess(ReduxInstance._id, id);
    if (res) {
      setNodes(res.data.view.filter((item) => item.type === "special"));
      setEdges(res.data.view.filter((item) => item.type !== "special"));
      setProcess(res.data);
      setProcessLoaded(true);
    } else {
      console.log("error");
    }
  };

  const onSubmit = async () => {
    let _nodes = reactFlowInstance.toObject().nodes;
    let _edges = reactFlowInstance.toObject().edges;

    const myForm = {
      view: _nodes.concat(_edges),
    };

    const res = await apiUpdateProcess(id, myForm);
    if (res) {
      setLastSave(new Date());
    } else {
      console.log("Error");
    }
  };

  const filterProcesses = (query) => {
    // Permet de filtrer tous les processus pour ne pas afficher ceux présents dans la vue
    var myArray = processes.filter(
      (elem) => !nodes.find((el) => el.data?.process._id === elem._id && el.data?.template === 0)
    );

    if (!query) {
      return myArray;
    }

    return myArray.filter((proc) => {
      const procName = proc.nom.toLowerCase();
      return procName.includes(query.toLowerCase());
    });
  };

  const filteredProcesses = filterProcesses(query);

  const onNodeClick = (event, element) => {
    if (event.target.matches(".no-interact")) {
      handleShowChoixResponsables(element);
    } else {
      setSelectedNode(element);
      handleShowNodeMenu();
    }
  };

  const onEdgeClick = (event, element) => {
    if (event.target.matches(".edgebutton")) {
      event.stopPropagation();
      setEdges((es) => applyEdgeChanges([{ id: element.id, type: "remove" }], es));
    }
  };

  const editTemplateNode = (id, template_id) => {
    setNodes((nds) =>
      nds.map((node) => {
        if (node.id === id) {
          node.data.template = template_id;
        }
        return node;
      })
    );
  };

  const handleShowCreateProcess = () => {
    setShowCreateProcess(true);
  };

  const handleCloseCreateProcess = () => {
    setSelectedNode("");
    setShowCreateProcess(false);
  };

  const handleShowChoixResponsables = (proc) => {
    setSelectedNode(proc);
    setShowChoixResponsables(true);
  };

  const handleCloseChoixResponsables = () => {
    setSelectedNode("");
    setShowChoixResponsables(false);
  };

  useEffect(() => {
    let myInterval = setInterval(() => {
      let now = new Date();
      setSeconds(now);
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  const getTimeSince = (date) => {
    let diff = seconds - date;
    let durationSecondes = ((diff % 60000) / 1000).toFixed(0);
    var durationMinutes = Math.floor(diff / 60000);
    if (durationMinutes <= 0) {
      return t("admin.PageAdminEditView.quelqueSeconds");
    } else {
      return t("admin.PageAdminEditView.lasSaveMinute", {
        val: durationMinutes,
      });
    }
  };

  const showCreateOnly = () => {
    handleCloseNodeMenu();
    handleShowCreateProcess();
  };

  const deleteNode = async () => {
    setNodes((ns) => applyNodeChanges([{ id: selectedNode.id, type: "remove" }], ns));
    if (selectedNode.data.template === 0) {
      await apiDeleteProcess(selectedNode.data.process._id);
      recupProcesses();
    }
    setSelectedNode("");
  };

  const goToView = (idProc) => {
    handleCloseNodeMenu();
    navigate("/admin/easygouv/processes/" + idProc + "/view");
  };

  return (
    <>
      {selectedNode ? (
        <Offcanvas
          style={{ height: "20vh" }}
          placement={"bottom"}
          show={showNodeMenu}
          onHide={handleCloseNodeMenu}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              {t("admin.PageAdminEditView.menuProcessTitre")} : {selectedNode.data.process.nom}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {selectedNode.data.template !== 0 ? (
              <>
                <h5>{t("commun.form.label.typeProcessus")} </h5>
                <Form.Check
                  inline
                  label={t("commun.form.label.entree")}
                  name="template"
                  type="radio"
                  checked={selectedNode.data.template === 1}
                  onChange={(e) => editTemplateNode(selectedNode.id, 1)}
                  id={1}
                />
                <Form.Check
                  inline
                  label={t("commun.form.label.sortie")}
                  name="template"
                  type="radio"
                  checked={selectedNode.data.template === 2}
                  onChange={(e) => editTemplateNode(selectedNode.id, 2)}
                  id={2}
                />{" "}
              </>
            ) : null}
            <div style={{ position: "fixed", bottom: 0, padding: 15 }}>
              <Button variant="danger" onClick={() => deleteNode(selectedNode.id)}>
                {t("commun.form.button.supprimer")}
              </Button>
              <Button
                style={{ marginLeft: 16 }}
                onClick={() => goToView(selectedNode.data.process._id)}
              >
                {t("commun.form.button.editerVue")}
              </Button>
              <Button style={{ marginLeft: 16 }} onClick={handleShowCreateProcess}>
                {t("commun.form.button.modifier")}
              </Button>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      ) : null}
      <ComponentMenu />
      <Container style={{ paddingBottom: 64 }}>
        <Link to="/admin/easygouv/processes" className="float-start">
          <MdArrowBack className="mt-2 me-2" size="1.5em" role="button" />
        </Link>
        <ComponentTitle title={t("admin.PageAdminEditView.titre") + " " + process.nom} />
        <ComponentBreadcrumb
          isForAdmin="true"
          ReduxInstanceId={ReduxInstance._id}
          idProcess={process._id}
        />
        <div
          style={{
            fontStyle: "italic",
            color: "#AAA",
            height: 25,
            textAlign: "end",
          }}
        >
          {lastSave
            ? t("admin.PageAdminEditView.derniereSauvegarde") + " " + getTimeSince(lastSave)
            : ""}
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            height: 700,
            border: "1px solid #F2F2F2",
          }}
        >
          <div
            className="process-menu"
            style={{
              flex: 1,
              borderRight: "1px solid #F2F2F2",
              padding: 16,
            }}
          >
            <div
              style={{
                marginBottom: 4,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div style={{ fontSize: 18, fontWeight: "bold" }}>
                {t("admin.PageAdminEditView.listProcessTitre")}
              </div>
              <Button
                style={{ alignSelf: "end", marginLeft: 8 }}
                variant="outline-primary"
                onClick={() => showCreateOnly()}
              >
                <MdOutlineAdd />
              </Button>
            </div>
            <Form.Control
              type="text"
              name="nom"
              placeholder={t("commun.form.placeholder.rechercheProcessus")}
              value={query}
              style={{ marginBottom: 16 }}
              onChange={(e) => setQuery(e.target.value)}
            />
            <Form.Check
              type="switch"
              id="custom-switch"
              label={t("commun.form.label.entree") + "/" + t("commun.form.label.sortie")}
              value={true}
              onChange={() => setEntryMode(!entryMode)}
            />
            <div style={{ height: 570, overflow: "scroll" }}>
              {filteredProcesses.map((process, key) => (
                <div
                  className="dndnode input"
                  onDragStart={(event) => onDragStart(event, "special", process)}
                  draggable
                  key={key}
                  style={
                    entryMode
                      ? {
                          // backgroundColor: "#217287",
                          backgroundColor: ReduxInstance.couleur,
                          borderRadius: 8,
                          padding: 8,
                          margin: 4,
                          color: "#FFF",
                          fontWeight: "bold",
                          fontSize: 12,
                          cursor: "pointer",
                        }
                      : {
                          // backgroundColor: "#393939",
                          backgroundColor: ReduxInstance.couleur,
                          borderRadius: 8,
                          padding: 8,
                          margin: 4,
                          color: "#FFF",
                          fontWeight: "bold",
                          fontSize: 12,
                          cursor: "pointer",
                        }
                  }
                >
                  {process.nom}
                </div>
              ))}
            </div>
          </div>
          <div
            className="dndflow"
            style={{
              flex: 3,
              borderRadius: 5,
              padding: 8,
              marginLeft: 8,
            }}
          >
            <ReactFlowProvider>
              <div className="reactflow-wrapper" style={{ height: 680 }} ref={reactFlowWrapper}>
                <ReactFlow
                  nodes={nodes}
                  edges={edges}
                  onNodesChange={onNodesChange}
                  onEdgesChange={onEdgesChange}
                  onNodeClick={onNodeClick}
                  onEdgeClick={onEdgeClick}
                  nodeTypes={nodeTypes}
                  edgeTypes={edgeTypes}
                  onInit={setReactFlowInstance}
                  onConnect={onConnect}
                  onDrop={onDrop}
                  onDragOver={onDragOver}
                  snapGrid={[50, 50]}
                  snapToGrid={true}
                  fitView
                >
                  <Controls />
                  <Background variant="lines" gap={100} size={1} />
                  <MiniMap
                    nodeColor={(node) => {
                      switch (node.data.template) {
                        case 0:
                          return "#505050";
                        case 1:
                          return ReduxInstance.couleur;
                        case 2:
                          return ReduxInstance.couleur;
                        default:
                          return "#eee";
                      }
                    }}
                    nodeStrokeWidth={3}
                  />
                </ReactFlow>
              </div>
            </ReactFlowProvider>
          </div>
        </div>
      </Container>
      <ModalCreateUpdate
        show={showCreateProcess}
        id={selectedNode ? selectedNode.data.process._id : null}
        handleClose={handleCloseCreateProcess}
        handleRecupDatas={selectedNode ? recupProcess : recupProcesses}
        handelAddProcess={addProcessToBoard}
        forceMacro={false}
      />
      {selectedNode ? (
        <ModalChoixResponsables
          show={showChoixResponsables}
          idProcess={selectedNode.data.process._id}
          handleClose={handleCloseChoixResponsables}
          ReduxInstanceId={ReduxInstance._id}
        />
      ) : null}
    </>
  );
};

export default PageAdminEditView;
